var $ = require('jquery');


$(function(){

    function markTopLevel (topAnchor) {
        if (topAnchor) {
            topAnchor.children('.js-nav-icon').addClass('dd-is-open');
            topAnchor.siblings('.js-nav-list').css('display', 'block');
        }
    }
    function markLevelTwo (level2Anchor) {
        if (level2Anchor) {
            markTopLevel(level2Anchor.closest('.js-nav-list-header-1').children('.js-nav-list-link'));

            level2Anchor.addClass('nav-list__link--view-all is-active');
            level2Anchor.siblings('.js-nav-list').css('display', 'block');
            level2Anchor.children('.js-nav-icon').addClass('dd-is-open');
        }
    }
    function markLevelThree (level3Anchor) {
        if (level3Anchor) {
            markLevelTwo(level3Anchor.closest('.js-nav-list-header-2').children('.js-nav-list-link'));
            level3Anchor.addClass('nav-list__link--view-all is-active');
        }
    }

    // toggle mobile left nav based on current url
    const highlightNavLink = $('#page-content').data('pageType') === 'plp';
    if (highlightNavLink) {
        const currentMenuLink = $('#js-nav-list-mobile').find('a.js-nav-list-link[href*="' + location.pathname + '"]');
        const level = currentMenuLink.data('level');
        switch (level) {
            case 1:
                markTopLevel(currentMenuLink);
                break;
            case 2:
                markLevelTwo(currentMenuLink);
                break;
            case 3:
                markLevelThree(currentMenuLink);
                break;
        }
    }
});

window.signOut = () => {
    $.ajax({
        type: 'POST',
        data: $.param({
            site: 'S'
        }),
        url: '/r/ajax/SignOut.jsp',
        success: function (data) {
            var obj = $.parseJSON(data);
            if (obj.success) {
                // Don't propagate bag sync URL parameters
                const currentPage = window.location.pathname;
                const parametersToRemove = ['bagSaved', 'bagSyncReason', 'syncBag'];
                let search = window.location.search;
                for (const param of parametersToRemove) {
                    const regex = new RegExp(`${param}=[^&$]*` , 'i');
                    search = search.replace(regex, '');
                }
                if (search === '?') {
                    search = '';
                }
                window.history.replaceState({}, document.title, `${currentPage}${search}`);
                location.reload();
            }
        }
    });
};


// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/index.js